/**
 * AR content for the "Antibes – Juan-les-Pins" private excursion.
 *
 * Role: Arabic (MSA) translation of slugs/antibes-juan-les-pins.ts, typed
 * `ExcursionPage` for the shared ExcursionSlugView.
 * Dependencies: slug-excursions (type), image. Slug mirrors FR (place names).
 */
import type { ExcursionPage } from "../slug-excursions";
import antibes from "@/assets/images/excursions/destinations/antibes.webp";

const page: ExcursionPage = {
  slug: "antibes-juan-les-pins",
  hero: {
    title: "رحلة أنتيب – جوان لي بان",
    subtitle: "أحجار عتيقة وأسوار وشواطئ أيقونية انطلاقًا من كان.",
    ctaPrimaryHref: "/reservation",
    ctaPrimaryLabel: "احجز الآن",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "اطلب عرض سعر",
    image: antibes,
  },
  highlights: {
    title: "أبرز المعالم",
    items: [
      { text: "الأسوار والسوق والبلدة القديمة في أنتيب" },
      { text: "جوان لي بان: شواطئ وغابة صنوبر وأجواء راقية" },
      { text: "متحف بيكاسو (حسب أوقات الفتح)" },
      { text: "كاب دانتيب ونقاط المشاهدة (اختياري)" },
    ],
  },
  itinerary: {
    title: "برنامج مقترح",
    steps: [
      {
        title: "أنتيب",
        description: "الأسوار والسوق البروفنسي والمتحف (اختياري).",
      },
      {
        title: "جوان لي بان",
        description: "شواطئ وميناء وممشى بحري.",
      },
      {
        title: "كاب دانتيب (اختياري)",
        description: "نقاط مشاهدة وصور.",
      },
    ],
  },
  practical: {
    title: "معلومات عملية",
    items: [
      { label: "المدة", value: "من 3 إلى 5 ساعات" },
      { label: "الانطلاق", value: "كان" },
      { label: "الموسم", value: "طوال السنة" },
      { label: "خيار", value: "المتحف / نقاط المشاهدة حسب الرغبة" },
    ],
  },
};

export default page;
